module.exports = __webpack_public_path__ + "static/media/git--gud-D-orange.94121b7b.svg";